import { Box, Dialog, Typography } from '@material-ui/core'
import { ToastMessageContext } from 'lib/contexts/message_context';
import React, { useContext, useEffect, useState } from 'react'
import FileUpload from "components/form_components/fileUpload";
import PlanningLineMaintenance from 'lib/services/api/planning/LineMaintenance/lineEventsandSeries';


const ViewWorkPack = (props) => {

    const {workOrderId, handleClose} = props;

    const [workPackFiles , setWorkPackFiles] = useState([]);  
    const [isFilesLoading , setIsFilesLoading] = useState(false);

    const message = useContext(ToastMessageContext)

         useEffect(()=>{
                getWorkPackFiles();
            } , [])
        
              const getWorkPackFiles = async () => {
                    const params = {
                        id: workOrderId,
                    }
                    setIsFilesLoading(true)
                    try{
                   const response =  await PlanningLineMaintenance.getWorkPackDocument(params);
                   if(response?.success){
                        setWorkPackFiles(response?.documents || []);
                        setIsFilesLoading(false);
                   }else{
                    setWorkPackFiles([]);
                    setIsFilesLoading(false);
                    throw new Error(response?.errors)
                   }
                }catch(error){
                    setIsFilesLoading(false);
                    message.showToastMessage({ message: error?.errors || error?.message || error?.error|| 'Something went wrong. Try again', variant: 'error' })
                }
                }
  return (
    <Dialog maxWidth="md" open={true} onClose={handleClose} >
        <Box width={"500px"} padding={"1.5rem"}>
          <Typography
            variant="body1"
            color="primary"
            >
           Workpack
          </Typography>


 <Box padding={"1rem 0rem 0.5rem 0rem"}>
               
                    <FileUpload
                    isLoading = {isFilesLoading}
                          defaultValue={workPackFiles}
                          APIUrl={""}
                          showBorderOnNoFiles={true}
                          multiple={true}
                          viewOnly={true}
                        /> 
                </Box>


                </Box>

          </Dialog>
  )
}

export default ViewWorkPack
